<template>
  <Layout style="height: 100%" class="main">
    <Sider hide-trigger collapsible :width="256" :collapsed-width="64" v-model="collapsed" class="left-sider" :style="{overflow: 'hidden'}">
      <side-menu accordion ref="sideMenu" :active-name="$route.name" :collapsed="collapsed" @on-select="turnToPage" :menu-list="menuList">
        <!-- 需要放在菜单上面的内容，如Logo，写在side-menu标签内部，如下 -->
        <div class="logo-con">
          <img v-show="!collapsed" :src="maxLogo" key="max-logo" />
          <img v-show="collapsed" :src="minLogo" key="min-logo" />
        </div>
      </side-menu>
    </Sider>
    <Layout>
      <Header class="header-con">
        <header-bar :collapsed="collapsed" @on-coll-change="handleCollapsedChange">
          <user :message-unread-count="unreadCount" :user-avatar="userAvatar"/>
        </header-bar>
      </Header>
      <Content class="main-content-con">
        <Layout class="main-layout-con">
          
          <Content class="content-wrapper">
            <keep-alive >
              <router-view/>
            </keep-alive>
          </Content>
        </Layout>
      </Content>
    </Layout>
  </Layout>
</template>
<style lang="scss">
@import './main.less';
</style>
<script>
import SideMenu from './components/side-menu'
import HeaderBar from './components/header-bar'
import User from './components/user'
import RequestUtils from "@/utils/RequestUtils";
import conf from "@/views/im/conf";

import minLogo from '@/static/img/logo-min.jpg'
import maxLogo from '@/static/img/logo.jpg'

export default {
  name: 'Main',
  components: {
    SideMenu,
    HeaderBar,
    User
  },
  data () {
    return {
      collapsed: false,
      minLogo,
      maxLogo,
    }
  },
  computed: {
    
    menuList () {
      return this.$store.getters.menuList
    },
    userAvatar () {
      return this.$store.state.user.avatar
    },
    unreadCount () {
      return this.$store.state.user.unreadCount
    }
  },
  methods: {
    turnToPage (route) {
      let { name, params, query } = {}
      if (typeof route === 'string') name = route
      else {
        name = route.name
        params = route.params
        query = route.query
      }
      if (name.indexOf('isTurnByHref_') > -1) {
        window.open(name.split('_')[1])
        return
      }
      this.$router.push({
        name,
        params,
        query
      })
    },
    handleCollapsedChange (state) {
      this.collapsed = state
    },
    userInfo() {
      let self = this;
      let param = new FormData();
      RequestUtils.request(conf.getUserinfoUrl(), param)
      .then(function (data) {
        self.$store.commit("setUser", data);
      })
    },
    socketInit() {
      let self = this;
      RequestUtils.request(conf.wsInitialize())
      .then(function (data) {
        RequestUtils.webSocketOperation(self, conf.getWsUrl()+'?driver=LazadaChat,ShopeeChat&token='+data.token);
      })
    },
    clearData() {
      this.$store.commit("lazada/clear");
      this.$store.commit("shopee/clear");
    },
    getChildUser() {
      let param = new FormData();
      RequestUtils.request(conf.getChildUser(), param)
      .then((json) => {            
        this.$store.commit("setChildUser", json);
      })
    },
  },
  created() {
    this.clearData();
    this.socketInit();
    this.userInfo();
    this.getChildUser();
  },
  mounted () {
    
  }
}
</script>
